import {PlusOutlined} from '@ant-design/icons'
import {Button, Form, Image, Input, Modal, Radio, Skeleton, Space, Spin} from 'antd'
import {
    exam_createExamQuestion_Api,
    exam_createExamQuestionSet_Api,
    exam_deleteExamQuestion_Api,
    exam_deleteExamQuestionSet_Api,
    exam_editExamQuestion_Api,
    exam_editExamQuestionSet_Api,
    exam_getExamQuestionAnswers_Api,
    exam_getExamQuestions_Api,
} from 'apis'
import {getId} from 'apis/model/base'
import classNames from 'classnames'
import FieldsFactory, {FieldHeader} from 'components/form/FieldsFactory'
import FormActionBar from 'components/form/FormActionBar'
import {createValue} from 'components/form/utils'
import {FullSideModalLayout} from 'components/Modal/SideModalLayout'
import Toggle from 'components/Toggle'
import UseState from 'components/UseState'
import {Formik, FormikConsumer} from 'formik'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import useAsync from 'modules/asyncCache/useAsync'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react'
import {BsCheckAll, BsInfoCircleFill,} from 'react-icons/bs'
import {FcNumericalSorting12} from 'react-icons/fc'
import {GoListOrdered} from 'react-icons/go'
import {useLocation} from 'react-router-dom'
import {withProps} from 'recompose'
import {getResponseItems, NullAsDefault, renderIf, renderSelf, shallowDiff,} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {appFieldTypes} from '../appFieldTypes'
import {modalWidth} from '../configs'
import {ExpandablePanel} from '../custom/AdvancedFormGroup'
import {appClassNames} from '../custom/appClassNames'
import PhotoField from '../custom/PhotoField'
import EntityList from '../EntityList'
import {showDeleteConfirmDialog} from '../factory/createConfirmDialog'
import createContextMenu from '../factory/createContextMenu'
import {notifyOnError} from '../factory/createErrorEvent'
import {createControlledFormField} from '../factory/createFormField'
import {NotificationActionTypes, successNotify,} from '../factory/createNotification'
import {bindQueryParam, bindQueryParams} from '../functions/routerHelper'
import DnDSorter from './components/DnDSorter'
import {UseExamQA} from './components/UseExamQA'
import {BooleanPicker} from './ExamContext'
import {examSortBy, QuestionTypes} from './ExaminationPaperContext'
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {renderDecoratedLabel} from "../../../components/form/FieldDecorator";
import {PiCheckCircle, PiCheckCircleFill} from "react-icons/pi";
import {ItemInformation} from 'components/common/ItemInformation'
import {HeaderWithIconLine} from "../Templates/items/ListHeader";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {ActionModalWrapper} from "../../../components/form/ActionModalWrapper";

const ExaminationQuestionSetContext = React.createContext({})


const AnswerOptions = ({
                           name,
                           value,
                           form,
                           onChange = NullAsDefault,
                           disabled = false,
                           options = [
                               QuestionTypes.TEXT,
                               QuestionTypes.BOOL,
                               QuestionTypes.SINGLE,
                               QuestionTypes.MULTIPLE,
                           ],
                           answers_field = 'exam_question_answers',
                       }) => {
    const t = useTranslate()
    const {setFieldValue} = form || {}
    const handleChange = (event) => {
        onChange(event)
        let answers = []
        switch (event.target.value) {
            case QuestionTypes.TEXT.value:
                answers = [{title: '', is_correct: true}]
                break
            case QuestionTypes.SINGLE.value:
                answers = [{title: ''}]
                break
            case QuestionTypes.MULTIPLE.value:
                answers = [{title: ''}, {title: ''}]
                break
            case QuestionTypes.BOOL.value:
                answers = appFieldTypes.yesOrno.map(({label, value}) => ({
                    title: t(label),
                }))
                break
            default:
                break
        }

        setFieldValue(
            answers_field,
            answers.map((answer, index) => ({
                ...answer,
                order_sort: index,
                id: _.uniqueId('__id_' + index),
            }))
        )
    }
    return (
        <div className="w-full">
            <Radio.Group
                name={name}
                value={value}
                optionType="button"
                buttonStyle="solid"
                disabled={disabled}
                onChange={handleChange}
                className="custom-radio-button">
                {options.map(({label, value}) => {

                    return value === 'text'
                        ? (
                            <Radio
                                disabled={true}
                                key={value}
                                value={value}>
                                {t(label)}
                            </Radio>
                        )
                        : (
                            <Radio
                                key={value}
                                value={value}>
                                {t(label)}
                            </Radio>
                        )
                })}
            </Radio.Group>
        </div>
    )
}

const QuestionAnswerRow = ({
                               type,
                               value,
                               index,
                               onUpdate,
                               onRemove,
                               move = NullAsDefault,
                               onChange = NullAsDefault,
                               canRemove = true,
                               editable = false,
                               onAnswerClick = NullAsDefault,
                               ...props
                           }) => {
    const t = useTranslate()

    const [isToggle, toggle] = useState()

    const {id, title, is_correct} = value || {}

    const setValues = (values) => {
        onChange({
            ...value,
            ...values,
        })
    }

    const onClick = () => {
        onAnswerClick(id)
    }

    const disabled_title = type === QuestionTypes.BOOL.value

    const is_text_question = type === QuestionTypes.TEXT.value

    return (
        <div className="flex items-center gap-2">
            {editable ? (
                <React.Fragment>
                    <div
                        onClick={() => {
                            toggle(true)
                        }}
                        className={classNames(
                            'px-2 py-1 flex items-center justify-between gap-2 flex-1 rounded-md background',
                            value?.is_correct
                                ? 'border-2 border-green-600 text-green-700'
                                : 'border text-color-100'
                        )}>
            <span className="text-sm flex-1">
              {value.title || (
                  <span className="font-light text-color-500 italic">
                  {t('content answer')}
                </span>
              )}
            </span>
                        {value?.is_correct ? (
                            <BsCheckAll
                                size={14}
                                className="text-green-500"
                            />
                        ) : null}
                    </div>
                    <BiSolidEdit
                        size={16}
                        onClick={() => {
                            toggle(true)
                        }}
                        className="cursor-pointer text-color-300 hover:text-primary"
                    />
                    <UseState initialValue={value}>
                        {([unsaved, setUnsaved]) => {
                            const handleChange = (event) => {
                                const {name, value} = event?.target || {}
                                setUnsaved({
                                    ...unsaved,
                                    [name]: value,
                                })
                            }
                            return (
                                <Modal
                                    centered={true}
                                    closable={false}
                                    open={isToggle}
                                    onCancel={() => {
                                        toggle(false)
                                    }}
                                    onOk={() => {
                                        onUpdate(unsaved, {id})
                                    }}
                                    okText={t('save')}
                                    cancelText={t('cancel')}
                                    okButtonProps={{
                                        className: 'button-rounded-lg no-border',
                                    }}
                                    cancelButtonProps={{
                                        className: 'button-rounded-lg no-border',
                                    }}
                                    destroyOnHidden={true}>
                                    <div className="uppercase font-bold text-center text-color-000 tracking-wide mb-4">
                                        {t('edit answer')}
                                    </div>
                                    <div className="flex flex-col gap-3">
                                        <div className="flex flex-col">
                                            {renderDecoratedLabel("content answer")}
                                            <Input.TextArea
                                                name="title"
                                                rows={3}
                                                placeholder={t('title')}
                                                onChange={handleChange}
                                                disabled={disabled_title}
                                                defaultValue={value?.title}
                                            />
                                        </div>
                                        <div className="flex flex-col">
                                            {renderDecoratedLabel("description")}
                                            <Input.TextArea
                                                rows={3}
                                                name="description"
                                                onChange={handleChange}
                                                placeholder={t('description')}
                                                defaultValue={value?.description}
                                            />
                                        </div>
                                        {!is_text_question && (
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                                <div className="flex flex-col">
                                                    {renderDecoratedLabel("is correct")}
                                                    <Radio.Group
                                                        name="is_correct"
                                                        onChange={handleChange}
                                                        defaultValue={value?.is_correct}>
                                                        {appFieldTypes.yesOrno.map(
                                                            ({label, value}, index) => (
                                                                <Radio
                                                                    key={index}
                                                                    value={value}>
                                                                    {t(label)}
                                                                </Radio>
                                                            )
                                                        )}
                                                    </Radio.Group>
                                                </div>
                                                <div className="flex flex-col">
                                                    {renderDecoratedLabel("order sort")}
                                                    <Input
                                                        type="number"
                                                        name="order_sort"
                                                        placeholder={t('order')}
                                                        onChange={handleChange}
                                                        defaultValue={value?.order_sort}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </Modal>
                            )
                        }}
                    </UseState>
                </React.Fragment>
            ) : is_text_question ? (
                <Input
                    name="title"
                    value={title}
                    disabled={disabled_title}
                    onChange={(event) => {
                        setValues({
                            [event.target.name]: event.target.value,
                        })
                    }}
                />
            ) : (
                <React.Fragment>
                    <Input
                        name="title"
                        value={title}
                        disabled={disabled_title}
                        onChange={(event) => {
                            setValues({
                                [event.target.name]: event.target.value,
                            })
                        }}
                    />
                    {is_correct ? (
                        <PiCheckCircleFill
                            size={16}
                            onClick={onClick}
                            className="text-green-500 cursor-pointer"
                        />
                    ) : (
                        <PiCheckCircle
                            size={16}
                            onClick={onClick}
                            className="cursor-pointer text-color-300 hover:text-primary"
                        />
                    )}
                </React.Fragment>
            )}
            {!is_text_question && (
                <BiTrash
                    size={16}
                    onClick={() => {
                        if (canRemove) {
                            onRemove(id)
                        }
                    }}
                    className={classNames(
                        canRemove
                            ? 'text-red-300 hover:text-red-600 cursor-pointer'
                            : 'cursor-not-allow text-color-500'
                    )}
                />
            )}
        </div>
    )
}

const QuestionAnswers = ({
                             name,
                             value,
                             onChange,
                             onCreate,
                             onDelete,
                             onUpdate,
                             answer_type,
                             question_id,
                             refreshToken,
                             editable = false,
                             sortAnswers = NullAsDefault,
                         }) => {
    const t = useTranslate()

    const [form_instance] = Form.useForm()

    const array_values = _.isArray(value) ? examSortBy(value) : []

    useEffect(() => {
        form_instance.setFieldsValue({
            [name]: examSortBy(value),
        })
    }, [value, answer_type])

    const getCorrect = useCallback(
        (is_correct) =>
            [QuestionTypes.BOOL.value, QuestionTypes.SINGLE.value].includes(
                answer_type
            )
                ? false
                : is_correct,
        [answer_type]
    )

    const toggleAnswer = (id) => {
        const new_value = Array.from(value).map(({is_correct, ...rest}) => ({
            ...rest,
            is_correct: rest.id === id ? !is_correct : getCorrect(is_correct),
        }))
        onChange(createValue(name, new_value))
    }

    const getRemoveOption = useCallback(
        (size) => {
            switch (answer_type) {
                case QuestionTypes.BOOL.value:
                case QuestionTypes.MULTIPLE.value:
                    return size > 2
                case QuestionTypes.SINGLE.value:
                    return size > 1
                default:
                    break
            }
            return size > 1
        },
        [answer_type]
    )

    const isDisabled = useCallback(
        (size) => {
            switch (answer_type) {
                case QuestionTypes.BOOL.value:
                    return size >= 2
                case QuestionTypes.MULTIPLE.value:
                case QuestionTypes.SINGLE.value:
                default:
                    break
            }
            return false
        },
        [answer_type]
    )

    const is_text_question = answer_type === QuestionTypes.TEXT.value

    return (
        <div className="flex flex-col">
            <FieldHeader title={t(is_text_question ? 'answer' : 'answers')}/>
            <Form
                layout="vertical"
                form={form_instance}
                onValuesChange={(changedValues, values) => {
                    const value = _.get(values, name)
                    onChange(createValue(name, value))
                }}>
                <Form.List
                    name={name}
                    initialValue={array_values}>
                    {(fields, {add, remove, move}, {errors}) => {
                        const disabled = isDisabled(fields.length)
                        const canRemove = getRemoveOption(fields.length)
                        return (
                            <div className="flex flex-col gap-2">
                                {!is_text_question && (
                                    <UseState>
                                        {([title, setTitle]) => (
                                            <Space.Compact
                                                compact
                                                style={{display: 'inline-flex'}}>
                                                <Input
                                                    name="title"
                                                    value={title}
                                                    disabled={disabled}
                                                    addonBefore={
                                                        Boolean(
                                                            !editable || _.isEmpty(array_values)
                                                        ) ? undefined : (
                                                            <DnDSorter
                                                                data={array_values}
                                                                className="flex flex-center cursor-pointer"
                                                                onSubmit={(array) => {
                                                                    sortAnswers({
                                                                        exam_question_answer_ids:
                                                                            Array.from(array).join(','),
                                                                    })
                                                                }}>
                                                                {({toggle}) => (
                                                                    <FcNumericalSorting12
                                                                        size={20}
                                                                        onClick={toggle}
                                                                    />
                                                                )}
                                                            </DnDSorter>
                                                        )
                                                    }
                                                    placeholder={t('type the answer and click')}
                                                    onChange={(event) => {
                                                        setTitle(event.target.value)
                                                    }}
                                                />
                                                <Button
                                                    type="primary"
                                                    disabled={_.isEmpty(title) || disabled}
                                                    icon={<PlusOutlined/>}
                                                    onClick={() => {
                                                        const _values = {
                                                            title,
                                                            order_sort:
                                                                _.defaultTo(
                                                                    (_.last(array_values) || {order_sort: 0})
                                                                        ?.order_sort,
                                                                    0
                                                                ) + 1,
                                                            id: _.uniqueId('__id_'),
                                                        }
                                                        if (_.isFunction(onCreate)) {
                                                            onCreate(_values)
                                                        } else {
                                                            add(_values)
                                                        }
                                                        setTitle('')
                                                    }}
                                                    className="no-shadow no-text-shadow text-sm font-medium">
                                                    {t('add')}
                                                </Button>
                                            </Space.Compact>
                                        )}
                                    </UseState>
                                )}
                                {fields.length > 0 && (
                                    <React.Fragment>
                                        <div
                                            style={fields.length > 4 ? {height: 160} : undefined}
                                            className={classNames(
                                                'flex flex-col space-y-2',
                                                !is_text_question &&
                                                'border rounded-md p-2 overflow-auto scrollBarThin'
                                            )}>
                                            {fields.map((field, index) => (
                                                <Form.Item
                                                    {...field}
                                                    noStyle={true}
                                                    key={field.key}>
                                                    <QuestionAnswerRow
                                                        move={move}
                                                        index={index}
                                                        type={answer_type}
                                                        editable={editable}
                                                        onUpdate={onUpdate}
                                                        canRemove={canRemove}
                                                        onAnswerClick={toggleAnswer}
                                                        onRemove={
                                                            canRemove
                                                                ? (id) => {
                                                                    if (_.isFunction(onDelete)) {
                                                                        onDelete({}, {id})
                                                                    } else {
                                                                        remove(field.name)
                                                                    }
                                                                }
                                                                : NullAsDefault
                                                        }
                                                    />
                                                </Form.Item>
                                            ))}
                                            <FormikConsumer>
                                                {({errors}) =>
                                                    renderIf(
                                                        _.get(errors, 'answers_error_container'),
                                                        <FieldsFactory
                                                            formSchema={[
                                                                {
                                                                    children: [
                                                                        {
                                                                            name: 'answers_error_container',
                                                                            component: NullAsDefault,
                                                                        },
                                                                    ],
                                                                },
                                                            ]}
                                                        />
                                                    )
                                                }
                                            </FormikConsumer>
                                        </div>
                                    </React.Fragment>
                                )}
                            </div>
                        )
                    }}
                </Form.List>
            </Form>
        </div>
    )
}

const formSchema = {
    title: {
        title: 'question set name',
        children: [
            {
                name: 'title',
                component: createControlledFormField({
                    placeholder: 'question set name',
                }),
            },
        ],
    },
    description: {
        title: 'short description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    rows: 5,
                    placeholder: 'short description',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
}

const questionsFormSchema = {
    title: {
        title: 'content questions',
        children: [
            {
                name: 'title',
                component: createControlledFormField({
                    rows: 3,
                    placeholder: 'content questions',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    description: {
        title: 'description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    rows: 5,
                    placeholder: 'description',
                    Component: Input.TextArea,
                }),
            },
        ],
    },
    boolean_1: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                name: 'is_mandatory',
                label: 'mandatory',
                component: BooleanPicker,
            },
            {
                name: 'point',
                label: 'point',
                component: createControlledFormField({
                    type: 'number',
                    placeholder: 'point',
                }),
            },
        ],
    },
    boolean_2: {
        inline: true,
        className: appClassNames.inline_2,
        children: [
            {
                name: 'is_fixed_orders',
                label: 'fixed orders',
                disabled: true,
                component: BooleanPicker,
            },
            {
                name: 'active',
                label: 'active',
                component: BooleanPicker,
            },
        ],
    },
    create_answer_type: {
        title: 'answer type',
        children: [
            {
                name: 'answer_type',
                component: AnswerOptions,
            },
        ],
    },
    edit_answer_type: {
        title: 'answer type',
        children: [
            {
                name: 'answer_type',
                disabled: true,
                component: AnswerOptions,
            },
        ],
    },
    create_question_answers: {
        children: [
            {
                name: 'exam_question_answers',
                component: withProps(({form, name, value, onChange}) => ({
                    name,
                    value,
                    onChange,
                    answer_type: form?.values?.answer_type,
                }))(QuestionAnswers),
            },
        ],
    },
    edit_question_answers: {
        children: {
            name: 'exam_question_answers',
            component: ({
                            name,
                            value,
                            answer_type,
                            onChange,
                            question_id,
                            refresh,
                        }) => (
                <UseExamQA
                    refresh={refresh}
                    question_id={question_id}>
                    {(props) => (
                        <QuestionAnswers
                            {...props}
                            {...{
                                name,
                                value,
                                onChange,
                                question_id,
                                answer_type,
                                editable: true,
                            }}
                        />
                    )}
                </UseExamQA>
            ),
        },
    },
    photo: {
        title: 'photos',
        children: [
            {
                name: 'photo',
                component: ({name, value, form, onChange}) => (
                    <PhotoField
                        className="background"
                        style={{
                            padding: 0,
                        }}
                        cropPurpose="exam_photo"
                        values={_.get(form, 'values')}
                        {...{name, value, onChange}}
                    />
                ),
            },
        ],
    },
}

const CreateQuestionModal = ({
                                 initialValues,
                                 onCancel = NullAsDefault,
                                 onSubmit = NullAsDefault,
                             }) => (
    <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
            onSubmit(values)
        }}
        enableReinitialize={true}>
        <ActionModalWrapper action={<FormActionBar submitText="create"/>}>
            <FieldsFactory formSchema={[formSchema.title, formSchema.description]}/>
        </ActionModalWrapper>
    </Formik>
)

const EditQuestionModal = ({
                               initialValues,
                               onCancel = NullAsDefault,
                               onSubmit = NullAsDefault,
                           }) => (
    <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
            onSubmit(values)
        }}
        enableReinitialize={true}>
        <ActionModalWrapper action={<FormActionBar submitText="save"/>}>
            <FieldsFactory formSchema={[formSchema.title, formSchema.description]}/>
        </ActionModalWrapper>
    </Formik>
)

const ExamQuestionInfo = ({item}) => {
    const t = useTranslate()

    return (
        <div className="flex flex-col gap-1 mb-3">
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <BsInfoCircleFill size={14} className="text-color-500"/>
                        <span className="font-bold text-sm text-color-400 uppercase tracking-wider">
                            {t('question set information')}
                        </span>
                    </div>
                )}
            />
            <div className="ml-2 flex flex-col gap-1">
                <ItemInformation primary={true} showIcon={true} label="questions set" value={getTitle(item)}
                                 className="text-xs italic"/>
                <ItemInformation showIcon={true} label="total of questions"
                                 value={`${_.get(item, 'total_questions')} ${t('ask')}`} className="text-xs italic"/>
                {_.get(item, 'description') && (
                    <span className="ml-1 text-xs text-color-400 italic">
                        {_.get(item, 'description')}
                    </span>
                )}
            </div>
        </div>
    )
}

const renderQuestionRow = ({isLg, translate: t ,renderContextMenu = NullAsDefault}) => (item, index) => {
    const {photo, description, answer_type, point, status, is_mandatory, is_fixed_orders} = item || {}

    const renderPhoto = ({style, className}) => {
        return photo ? (
            <Image
                src={photo}
                style={style}
                preview={false}
                className={className}
            />
        ) : (
            <Skeleton.Image
                style={style}
                className={className}
            />
        )
    }

    return (
        <div className="p-3 flex items-center gap-2 custom-item-render relative list-item">
            {isLg && (
                renderPhoto({
                    style: {width: '5rem', height: '5rem', borderRadius: '0.5rem'},
                    className: 'object-cover background-100',
                })
            )}
            <div className="py-1 flex flex-col flex-1 gap-1">
                <div className="font-semibold text-sm text-color-000 leading-snug mr-6">
                    <span className="font-normal text-color-500 italic">
                        {`${t('ask')} : `}
                    </span>
                    {getTitle(item)}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-1">
                    <ItemInformation showIcon={true} label={t('question type')} value={t(answer_type)}
                                     className="text-xs italic"/>
                    {status !== -1 && (
                        <ItemInformation showIcon={true} label={t('point')} value={t(point)}
                                         className="text-xs italic"/>
                    )}
                    {status === -1 && (
                        <ItemInformation
                            label={t('status')}
                            value={<span className="text-red-600">{t('not ready')}</span>}
                            className="text-xs italic"
                        />
                    )}
                    <ItemInformation showIcon={true} label={t('mandatory')}
                                     value={is_mandatory === 1 ? t('yes') : t('no')}
                                     className="text-xs italic"/>
                    <ItemInformation showIcon={true} label={t('fixed orders')}
                                     value={is_fixed_orders === 1 ? t('yes') : t('no')}
                                     className="text-xs italic"/>
                </div>
                {description && (
                    <div className="text-xs text-color-300 italic max-lines-1">
                        {description}
                    </div>
                )}
            </div>
            <div className="absolute right-5 top-5 contextIcon">
                {renderContextMenu(item)}
            </div>
        </div>
    )
}

const CreateExamQuestionModal = ({onSubmit = NullAsDefault}) => {
    const t = useTranslate()

    const initialValues = {
        point: 0,
        active: 1,
        is_mandatory: 0,
        title: undefined,
        is_fixed_orders: 1,
        photo: undefined,
        description: undefined,
        photo_preview: undefined,
        answer_type: QuestionTypes.TEXT.value,
        exam_question_answers: [
            {title: '', is_correct: true, id: _.uniqueId('__id_')},
        ],
    }

    const validate = (values) => {
        let errors = {}

        const {title, point, answer_type, exam_question_answers} = values || {}

        if (!title) {
            errors.title = t('required field')
        }

        if (!point) {
            errors.point = t('required field')
        }

        if (_.isEmpty(answer_type)) {
            errors.answer_type = t('required field')
        }

        if (_.isEmpty(exam_question_answers)) {
            errors.answers_error_container = t('required field')
        } else if (_.some(exam_question_answers, ({title}) => _.isEmpty(title))) {
            errors.answers_error_container = t('required field')
        } else if (
            _.every(exam_question_answers, ({is_correct}) => !is_correct)
        ) {
            errors.answers_error_container = t('missing correct answer')
        }

        return errors
    }

    return (
        <Formik
            onSubmit={(values) => {
                const {exam_question_answers, ...rest} = values || {}
                onSubmit(
                    _.omitBy(
                        {
                            ...rest,
                            exam_question_answers: _.isEmpty(exam_question_answers)
                                ? undefined
                                : JSON.stringify(
                                    Array.from(exam_question_answers).map(
                                        ({id, is_correct, ...item}, index) => ({
                                            ...item,
                                            order_sort: index,
                                            is_correct: _.defaultTo(Number(is_correct), 0),
                                        })
                                    )
                                ),
                        },
                        _.isUndefined
                    )
                )
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper action={<FormActionBar submitText="create"/>}>
                <div className="uppercase text-center text-color-000 font-bold">
                    {t('create question')}
                </div>
                <FieldsFactory
                    formSchema={[
                        questionsFormSchema.create_answer_type,
                        questionsFormSchema.photo,
                        questionsFormSchema.title,
                        questionsFormSchema.create_question_answers,
                        questionsFormSchema.boolean_1,
                    ]}
                />
                <Toggle>
                    {(isToggle, toggle) => (
                        <ExpandablePanel
                            onClick={toggle}
                            expanded={isToggle}>
                            <div className="flex flex-col gap-3 p-2">
                                <FieldsFactory
                                    formSchema={[
                                        questionsFormSchema.description,
                                        questionsFormSchema.boolean_2,
                                    ]}
                                />
                            </div>
                        </ExpandablePanel>
                    )}
                </Toggle>
            </ActionModalWrapper>
        </Formik>
    )
}

const EditExamQuestionModal = ({item, onSubmit = NullAsDefault}) => {
    const t = useTranslate()

    const location = useLocation()

    const validate = (values) => {
        let errors = {}

        const {title, point, answer_type} = values || {}

        if (!title) {
            errors.title = t('required field')
        }

        if (!point) {
            errors.point = t('required field')
        }

        if (_.isEmpty(answer_type)) {
            errors.answer_type = t('required field')
        }

        return errors
    }

    const question_id = getId(item)

    const refreshKey = location?.state?.refreshToken

    const {
        response,
        isLoading = false,
        handleAsyncAction,
    } = useAsync({
        query: bindQueryParam({id: question_id}),
        apiInfo: exam_getExamQuestionAnswers_Api,
    })

    useEffect(() => {
        if (refreshKey) {
            handleAsyncAction()
        }
    }, [refreshKey])

    const initialValues = useMemo(
        () => ({
            ...item,
            refreshKey,
            photo_preview: undefined,
            exam_question_answers: getResponseItems(response),
        }),
        [item, response, refreshKey]
    )

    return (
        <Formik
            onSubmit={(values) => {
                const {photo_preview, exam_question_answers, ...rest} = values || {}
                const changed = shallowDiff(rest, initialValues)

                onSubmit(_.omitBy(changed, _.isUndefined))
            }}
            validate={validate}
            validateOnMount={true}
            validateOnChange={true}
            enableReinitialize={true}
            initialValues={initialValues}>
            <ActionModalWrapper action={<FormActionBar submitText="save"/>}>
                <div className="uppercase text-center text-color-000 font-bold">
                    {t('edit question')}
                </div>
                <FieldsFactory
                    formSchema={[
                        questionsFormSchema.edit_answer_type,
                        questionsFormSchema.photo,
                        questionsFormSchema.title,
                    ]}
                />
                <FormikConsumer>
                    {({values, handleChange}) => {
                        const {answer_type} = values || {}
                        const {name, component: Component} =
                            questionsFormSchema.edit_question_answers.children
                        return (
                            <Spin spinning={!!isLoading}>
                                <Component
                                    {...{
                                        name,
                                        answer_type,
                                        question_id,
                                        value: _.get(values, name),
                                        refresh: ({history}) => {
                                            if (history) {
                                                history.push({
                                                    ...(history?.location || {}),
                                                    state: {
                                                        ...(history?.location?.state || {}),
                                                        refreshToken: Date.now(),
                                                    },
                                                })
                                            }
                                        },
                                        onChange: handleChange,
                                    }}
                                />
                            </Spin>
                        )
                    }}
                </FormikConsumer>
                <FieldsFactory formSchema={[questionsFormSchema.boolean_1]}/>
                <Toggle>
                    {(isToggle, toggle) => (
                        <ExpandablePanel
                            onClick={toggle}
                            expanded={isToggle}>
                            <div className="flex flex-col gap-3 p-2">
                                <FieldsFactory
                                    formSchema={[
                                        questionsFormSchema.description,
                                        questionsFormSchema.boolean_2,
                                    ]}
                                />
                            </div>
                        </ExpandablePanel>
                    )}
                </Toggle>
            </ActionModalWrapper>
        </Formik>
    )
}

const ExamQuestionsModal = ({
                                item,
                                owner_id,
                                owner_type,
                                header = null,
                                renderFooter = renderSelf,
                            }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const id = getId(item)

    const [refreshKey, setRefreshKey] = useState()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const onError = notifyOnError(t)

    const reload = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const {handleAsyncAction: onCreate} = useAsyncAction({
        apiInfo: exam_createExamQuestion_Api,
        query: bindQueryParam({id}),
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: exam_editExamQuestion_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onDelete} = useAsyncAction({
        apiInfo: exam_deleteExamQuestion_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            reload()
        },
    })

    const handleAction = (action, params) => {
        const {id} = params || {}
        switch (action) {
            case CRUD.CREATE:
            case CRUD.UPDATE:
                setAction({type: action, value: params})
                break
            case CRUD.DELETE:
                if (id) {
                    showDeleteConfirmDialog({
                        translate: t,
                        title: 'delete question',
                        message: 'are you sure you want to delete it question',
                        onOk: () => {
                            onDelete({}, {id})
                        },
                    })
                }
                break
            default:
                break
        }
    }

    const onCancel = () => {
        setAction({})
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: CRUD.UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CRUD.DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const modal = useMemo(() => {
        switch (action.type) {
            case CRUD.CREATE:
                return (
                    <Modal
                        className="custom-modal"
                        footer={null}
                        onCancel={onCancel}
                        open={action.type}
                        destroyOnHidden={true}
                        width={modalWidth.large}>
                        <CreateExamQuestionModal
                            onSubmit={(values) => {
                                onCreate(values)
                            }}
                            {...{onCancel, owner_id, owner_type}}
                        />
                    </Modal>
                )
            case CRUD.UPDATE:
                return (
                    <Modal
                        className="custom-modal"
                        footer={null}
                        onCancel={onCancel}
                        open={action.type}
                        destroyOnHidden={true}
                        width={modalWidth.large}>
                        <EditExamQuestionModal
                            item={action.value}
                            onSubmit={(values) => {
                                onUpdate(values, {id: getId(action.value)})
                            }}
                            {...{onCancel, owner_id, owner_type}}
                        />
                    </Modal>
                )
            default:
                break
        }
        return null
    }, [action, owner_id, owner_type])

    return (
        <ActionModalWrapper className="flex-1 p-3">
            {header}
            <div className="flex flex-col space-y-4 flex-1">
                <ExamQuestionInfo item={item}/>
                <div className="flex items-center gap-2">
                    <span className="font-medium text-sm text-color-300 uppercase">
                        {t('list of questions')}
                    </span>
                    <div className="flex-1 border-b border-color-50"/>
                    <Button
                        size="small" color="primary" variant="filled"
                        className="flex flex-center button-rounded-md no-border font-medium text-xs px-3"
                        onClick={() => {
                            handleAction(CRUD.CREATE)
                        }}>
                        {t('create')}
                    </Button>
                </div>
                <EntityList
                    key={refreshKey}
                    query={bindQueryParam({id})}
                    RenderEntity={React.Fragment}
                    apiInfo={exam_getExamQuestions_Api}
                    renderItem={renderQuestionRow({isLg: isLg, translate: t, renderContextMenu})}
                    renderWrap={(child) => (
                        <div className="flex flex-col divide-y divide-gray-200 list-item-workspace">
                            {child}
                        </div>
                    )}
                />
            </div>
            {renderFooter(null)}
            {modal}
        </ActionModalWrapper>
    )
}

export const ExaminationQuestionSetProvider = ({
                                                   owner_id,
                                                   owner_type,
                                                   children,
                                                   ...props
                                               }) => {
    const t = useTranslate()

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const [refreshKey, setRefreshKey] = useState()

    const onError = notifyOnError(t)

    const onCancel = () => {
        setAction({})
    }

    const reload = () => {
        setRefreshKey(Date.now())
        onCancel()
    }

    const {handleAsyncAction: onCreate} = useAsyncAction({
        apiInfo: exam_createExamQuestionSet_Api,
        query: bindQueryParams([{id: owner_id}, {type: owner_type}]),
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onUpdate} = useAsyncAction({
        apiInfo: exam_editExamQuestionSet_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.UPDATE, t)
            reload()
        },
    })

    const {handleAsyncAction: onDelete} = useAsyncAction({
        apiInfo: exam_deleteExamQuestionSet_Api,
        onError,
        onSuccess: () => {
            successNotify(NotificationActionTypes.DELETE, t)
            reload()
        },
    })

    const confirmDelete = useCallback(
        (id) => {
            if (id) {
                showDeleteConfirmDialog({
                    translate: t,
                    title: 'delete question set',
                    message: 'are you sure you want to delete it question set',
                    onOk: () => {
                        onDelete({}, {id})
                    },
                })
            }
        },
        [onDelete]
    )

    const handleAction = (action, params) => {
        const {id} = params || {}
        switch (action) {
            case 'questions':
            case CRUD.CREATE:
            case CRUD.UPDATE:
                setAction({type: action, value: params})
                break
            case CRUD.DELETE:
                confirmDelete(id)
                break
            default:
                break
        }
    }

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <GoListOrdered size={14} className="text-green-600"/>,
                        label: 'list of questions',
                        key: 'questions',
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: CRUD.UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CRUD.DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const modal = useMemo(() => {
        const {id} = action.value || {}
        let title
        let Content = NullAsDefault
        let params = {title: undefined}
        switch (action.type) {
            case 'questions':
                return (
                    <FullSideModalLayout
                        right={true}
                        title={
                            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                                {t('questions set')}
                            </div>
                        }
                        onCancel={onCancel}>
                        <ExamQuestionsModal
                            item={action.value}
                            {...{onCancel, owner_id, owner_type}}
                        />
                    </FullSideModalLayout>
                )
            case CRUD.CREATE:
                title = (
                    <div className="uppercase text-center font-bold text-color-000">
                        {t('create question set')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onCreate(values)
                    },
                }
                Content = CreateQuestionModal
                break
            case CRUD.UPDATE:
                title = (
                    <div className="uppercase text-center font-bold text-color-000">
                        {t('update question set')}
                    </div>
                )
                params = {
                    onCancel,
                    onSubmit: (values) => {
                        onUpdate(values, {id})
                    },
                }
                Content = EditQuestionModal
                break
            default:
                break
        }
        return (
            <Modal
                className="custom-modal"
                footer={null}
                title={title}
                onCancel={onCancel}
                open={action.type}
                destroyOnHidden={true}>
                <Content
                    {...params}
                    initialValues={action.value || {}}
                />
            </Modal>
        )
    }, [action])

    return (
        <ExaminationQuestionSetContext.Provider
            key={JSON.stringify({owner_id, owner_type})}
            value={{
                action,
                owner_id,
                owner_type,
                refreshKey,
                handleAction,
                renderContextMenu,
                ...props,
            }}>
            {children}
            {modal}
        </ExaminationQuestionSetContext.Provider>
    )
}

export default ExaminationQuestionSetContext
